<div class="login-page">
  <div class="login-card">
    <img
      class="login-wordmark"
      src="/assets/images/vive-logo-navy.svg"
      alt="VIVE"
    />
    <form [formGroup]="loginForm" (keyup.enter)="login()">
      <h1 class="text-center">Welcome back</h1>
      <h2 class="text-center">Sign in to your VIVE account.</h2>
      @if (ssoErrorMessage(); as message) {
        <div class="alert alert-danger mb-3" role="alert">{{ message }}</div>
      }
      <label
        for="inputEmail"
        [class.invalid]="
          loginForm.controls['userEmail'].invalid &&
          (loginForm.controls['userEmail'].dirty ||
            loginForm.controls['userEmail'].touched)
        "
        class="sr-only"
        >Email address</label
      >
      <input
        type="email"
        name="userEmail"
        id="inputEmail"
        formControlName="userEmail"
        class="form-control"
        placeholder="Email address"
        required
        autofocus
        (blur)="ssoLogin.discover()"
      />
      @if (
        loginForm.controls['userEmail'].invalid &&
        (loginForm.controls['userEmail'].dirty ||
          loginForm.controls['userEmail'].touched)
      ) {
        <div class="alert alert-danger">
          @if (loginForm.controls['userEmail'].errors?.['required']) {
            <span>Email address is required.</span>
          }
          @if (
            loginForm.controls['userEmail'].errors?.['emailPattern'] &&
            !loginForm.controls['userEmail'].errors?.['required']
          ) {
            <span>Email address must be a valid email address format.</span>
          }
        </div>
      }
      <label
        for="inputPassword"
        [class.invalid]="
          loginForm.controls['userPassword'].invalid &&
          (loginForm.controls['userPassword'].dirty ||
            loginForm.controls['userPassword'].touched)
        "
        class="sr-only"
        >Password</label
      >
      <app-password-field
        [passwordFormControl]="$any(loginForm.controls['userPassword'])"
      ></app-password-field>
      @if (
        loginForm.controls['userPassword'].invalid &&
        (loginForm.controls['userPassword'].dirty ||
          loginForm.controls['userPassword'].touched)
      ) {
        <div class="alert alert-danger">
          @if (loginForm.controls['userPassword'].errors?.['required']) {
            <span>Password is required</span>
          }
        </div>
      }
      <button
        class="btn btn-lg btn-primary btn-block"
        [disabled]="loginForm.invalid"
        (click)="login()"
        type="button"
      >
        Sign in
      </button>
      <app-sso-login-button
        #ssoLogin
        [emailControl]="loginForm.controls['userEmail']"
      ></app-sso-login-button>
      <p>
        <a href="javascript:void(0)" (click)="forgotPassword()"
          >Forgot password?</a
        >
      </p>
    </form>
  </div>
</div>
